/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Janus from './janus';

function getQueryStringValue(n) {
  const name = n.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp(`[\\?&]${  name  }=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

const doSimulcast = (getQueryStringValue("simulcast") === "yes" || getQueryStringValue("simulcast") === "true");
// eslint-disable-next-line no-unused-vars
let yourusername = null;

export function publishToRoom(
  janus,
  opaqueId,
  username,
  isPublisher,
  callback,
) {
  let sfutest = null;
  let mystream = null;

  if (!janus) {
    return;
  }

  janus.attach({
    plugin: 'janus.plugin.videocall',
    opaqueId,
    success(pluginHandle) {
      sfutest = pluginHandle;
      Janus.log(`Plugin attached! (${ sfutest.getPlugin() }, id=${ sfutest.getId() })`);
      sfutest.send({ message: { request: "register", username } });
    },
    error(error) {
      Janus.log('  -- Error attaching plugin...', error);
      callback(sfutest, 'error', error);
    },
    consentDialog(on) {
      Janus.debug(`Consent dialog should be ${on ? 'on' : 'off'} now`);
    },
    mediaState(medium, on) {
      Janus.log(`Janus ${on ? 'started' : 'stopped'} receiving our ${medium}`);
    },
    webrtcState(on) {
      Janus.log(
        `Janus says our WebRTC PeerConnection is ${on ? 'up' : 'down'} now`,
      );
      callback(sfutest, on ? 'up' : 'down');
    },
    onmessage(msg, jsep) {
      Janus.log('::: Got message', msg);

      if (msg.videocall !== undefined && msg.videocall !== null) {
        if (msg.error !== undefined && msg.error !== null) {
          callback(sfutest, 'error', msg);
        } 

        const {event, list, username: name, reason} = msg.result;

        if(list) {
          Janus.debug("Got a list of registered peers:", list);
          for (const mp in list) {
            Janus.debug(`>> [${  list[mp]  }]`);
          }
        }

        if (event === 'registered') {
          callback(sfutest, 'registered', msg);
        } else if(event === 'calling') {
          Janus.log("Waiting for the peer to answer...");
          callback(sfutest, 'calling');
        } else if(event === 'incomingcall') {
          Janus.log(`Incoming call from ${  name  }!`);
          yourusername = name;
          sfutest.createAnswer({
            jsep,
            media: { data: true },
            simulcast: doSimulcast,
            success (_jsep) {
              Janus.debug("Got SDP!", _jsep);
              sfutest.send({ message: { request: 'accept' }, jsep: _jsep });
            },
            error (error) {
              Janus.error("WebRTC error:", error);
            }
          })
        } else if(event === 'accepted') {
          if(!name) {
            Janus.log("Call started!");
          } else {
            Janus.log(`${name} accepted the call!`);
            yourusername = name;
            callback(sfutest, 'accepted', yourusername);
          }
          if(jsep) {
            sfutest.handleRemoteJsep({ jsep });
          }
        } else if(event === 'update'){
          if(jsep) {
            if(jsep.type === 'answer') {
              sfutest.handleRemoteJsep({ jsep });
            } else {
              sfutest.createAnswer({
                jsep,
                media: { data: true },
                success (_jsep) {
                  Janus.debug("Got SDP!", _jsep);
                  sfutest.send({ message: { request: "set" }, jsep: _jsep });
                },
                error (error) {
                  Janus.error("WebRTC error:", error);
                }
              });
            }
          }
        } else if (event === 'hangup') {
          Janus.log(`Call hung up by ${ name } (${ reason })!`);
          callback(sfutest, 'hangup', msg);
        } else if (event === 'event') {
          if (msg.error !== undefined && msg.error !== null) {
            callback(sfutest, 'error', msg);
          } else if (
            msg.unpublished !== undefined &&
            msg.unpublished !== null
          ) {
            callback(sfutest, 'unpublished', msg);
          }
        }
      }

      if (jsep !== undefined && jsep !== null) {
        Janus.debug('Handling SDP as well...');
        Janus.debug(jsep);
        sfutest.handleRemoteJsep({ jsep });
        // Check if any of the media we wanted to publish has
        // been rejected (e.g., wrong or unsupported codec)
        const audio = msg.audio_codec;
        if (
          mystream &&
          mystream.getAudioTracks() &&
          mystream.getAudioTracks().length > 0 &&
          !audio
        ) {
          // Audio has been rejected
          Janus.log(
            "Our audio stream has been rejected, viewers won't hear us",
          );
        }
        const video = msg.video_codec;
        if (
          mystream &&
          mystream.getVideoTracks() &&
          mystream.getVideoTracks().length > 0 &&
          !video
        ) {
          Janus.log("Our video stream has been rejected, viewers won't see us");
        }
      }
    },
    onlocalstream(stream) {
      Janus.debug(' ::: Got a local stream :::');
      mystream = stream;
      callback(sfutest, 'onlocalstream', stream);
    },
    onremotestream(stream) {
      // The publisher stream is sendonly, we don't expect anything here
      Janus.debug(' ::: Got a Remote stream :::');
      callback(sfutest, 'onremotestream', stream);
    },
    oncleanup() {
      Janus.log(' ::: Got a cleanup notification: we are unpublished now :::');
      yourusername = null;
      callback(sfutest, 'oncleanup');
    },
    destroyed() {
      window.location.reload();
    }
  });
}

export function calling(sfutest, callee, useAudio) {
  // Publish our stream
  sfutest.createOffer({
    // Add data:true here if you want to publish datachannels as well
    media: {
      data: true
    },
    simulcast: false,
    success(jsep) {
      Janus.debug('Got publisher SDP!');
      Janus.debug(jsep);

      const body = { request: "call", username: callee };
      sfutest.send({ message: body, jsep });
    },
    error(error) {
      Janus.error('WebRTC error:', error);
      if (useAudio) {
        calling(sfutest, false);
      } else {
        Janus.log(`Error publishing feed: ${error}`);
      }
    },
  });
}

export function hangUp(sfutest) {
  // Unpublish our stream
  const hangup = { request: 'hangup' };
  sfutest.send({ message: hangup });
  sfutest.hangup();
  yourusername = null;
}
